import { render, staticRenderFns } from "./certificate-modal.vue?vue&type=template&id=4a85880a&"
import script from "./certificate-modal.vue?vue&type=script&lang=js&"
export * from "./certificate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports